import { render, staticRenderFns } from "./WabaSupsisPartnerRemove.vue?vue&type=template&id=585ca95e&scoped=true"
import script from "./WabaSupsisPartnerRemove.vue?vue&type=script&lang=js"
export * from "./WabaSupsisPartnerRemove.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisPartnerRemove.vue?vue&type=style&index=0&id=585ca95e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585ca95e",
  null
  
)

export default component.exports